// extracted by mini-css-extract-plugin
export default {"container":"K5fMwg1_zoKlI5ZuFWgf","content":"lE3egUFk9WjJWPgeq252","message":"ypl2v4Ugx4wOpWgLzCCR","error":"_w5OJe_GdnijgXRJzoZk"};